<template>
<div class="row">
    <div class="large-5 columns"> <img src="/static/imgs/28719-640-transp.png" alt=""> </div>
    <div class="large-7 columns top">
        <div class="panel" @click="changePwd">
            <div class="panel-title"> Changement de mot de passe
                <hr>
            </div>
            <div v-if="requestStatus === null || requestStatus !== 200" class="panel-content">
                    <div class="row columns">
                        <div class="large-12 columns">
                            <label >Saisissez un nouveau mot de passe</label>
                            <div class="notes">il faut confirmer le mot de passe afin d'éviter les erreurs</div>
                        </div>
                    </div>
                    <br>
                    <div class="row columns">
                        <div class="large-12 columns">
                          <p :class="{ 'control': true }">
                            <input
                              v-model="password"
                              :class="{'valid': !minLengthError, 'invalid': minLengthError}"
                              name="password"
                              type="password"
                              placeholder="mot de passe"
                              v-on:blur="checkPwd">
                              <div v-show="minLengthError" class="is-danger">
                                <span><i class="fa fa-times" aria-hidden="true"></i></span>On a dit 6 caractères minimum.
                              </div>

                            <input
                              v-model="confirm"
                              name="confirm"
                              type="password"
                              placeholder="confirmation"
                              :class="{'valid': !pwdConfirmError, 'invalid':pwdConfirmError }"
                              v-on:blur="checkConfirm()">
                            <div v-show="pwdConfirmError" class="is-danger">
                                <span><i class="fa fa-times" aria-hidden="true"></i></span>le mot de passe et la confirmation ne collent pas
                            </div>
                          </p>
                        </div>
                    </div>
                    <br>
                    <spinner v-if="requestSent"></spinner>
                    <div class="row columns">
                        <div class="large-4 columns">
                            <router-link to="/home"><button class="full-width light-grey-button">Retour</button></router-link>
                        </div>
                        <div class="large-4 columns">
                            <button
                            @click="changePwd"
                            :disabled="!submissionEnabled"
                            class="full-width">Valider</button>
                        </div>
                    </div>
            </div>
            <div v-if="requestStatus === 200" class="panel-content">
                <div class="row columns">
                    <div class="large-12 columns large-centered">
                        <h3>Done !</h3>
                        <div>Votre mot de passe est maintenant changé, et vous pouvez vous connecter. Welcome Back.</div>
                    </div>
                </div>
                <br>
                <br>
                <div class="row">
                    <div class="large-4 large-centered columns">
                        <router-link to="/home"><button class="full-width light-grey-button">Retour</button></router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import auth from '../../api/auth.api'
import spinner from '../common/spinner.vue'
import store from '../../store/index.js'

export default {
  name: 'resetPwd',
  components: {
    spinner
  },
  props: {
    'uid': String,
    'token': String
  },
  computed:
  {
    submissionEnabled: function () {
      if (this.password === null || this.confirm === null || this.password !== this.confirm) {
        return false
      }
      return true
    }
  },
  data () {
    return {
      password: null,
      confirm: null,
      requestSent: false,
      requestStatus: null,
      // errors
      minLengthError: false,
      pwdConfirmError: false
    }
  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('deactivateFullSizePage')
  },
  methods: {
    checkPwd () {
      this.minLengthError = false
      if (this.password !== '' && this.password.length < 6) {
        this.minLengthError = true
      }
    },
    checkConfirm () {
      this.pwdConfirmError = false
      if (this.password !== this.confirm || this.confirm === '') {
        this.pwdConfirmError = true
      }
    },
    changePwd () {
      if (this.minLengthError || this.pwdConfirmError) {
        console.log('erreur sac à merde')
        return
      }
      this.requestSent = true
      auth.api.changePwd(this.password, this.confirm, this.uid, this.token)
      .then(response => {
        this.requestSent = false
        console.log(response.status)
        this.requestStatus = response.status
      },
      error => {
        this.requestSent = false
        this.requestStatus = error.status
        if (this.requestStatus === 400) {
          this.errors.add('password', 'Impossible d\'éxécuter la requête', 'request')
          this.errors.first('password:request')
        }
      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-error {
  text-align: center;
  color: #CC0000;
}

.form-group {
  border-radius: 8px;
}

.notes {
  font-size: 0.7rem;
  font-weight: 300;
  color: #2F353B;
  text-align: left;
}

label {
  font-size: 1rem;
  color: #2F353B;
  font-weight: 500;
  text-align: left;
}

.is-danger {
  color:#E7505A;
}

.message {
  margin-top: 0.4rem;
  margin-left: 0rem;
  padding-left: 0rem;
  font-size: 0.9rem;
  text-align: left;
}

input.invalid{
  border-left: 3px solid #a94442;
}

input.valid{
  border-left: 3px solid #42A948; /* green */
}

input.untouched{
  border-left: 3px solid #ACB5C3;
}
</style>



// WEBPACK FOOTER //
// reset-password.vue?799d9cce